<template>
    <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo">Dados do Processo</h3>
        <v-layout wrap align-center white>
            <v-flex xs12 sm3 d-flex>
                <div id="numeroProcesso" class="az-text">
                    <label>Nº Processo</label>
                    <p>
                        {{ value.processo || '--' }}
                    </p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="orgao" class="az-text">
                    <label>{{ $t('main.commons_painel_processo_visualizacao.text') }}</label>
                    <p>{{ value.orgao || '--' }}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="unidade" class="az-text">
                    <label> Unidade Organizacional</label>
                    <p>{{ value.unidadeOrganizacional || '--' }}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm12 d-flex>
                <div id="objeto" class="az-text">
                    <label>Objeto</label>
                    <p>{{value.objeto || '--'}}</p>
                </div>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
export default {
    name: 'PainelProcessoLegadoVisualizacao',
    props: {
        value: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped lang="stylus">

</style>